module.exports = __webpack_public_path__ + "static/media/shipping-fast.41fc4b41.svg";